export function getNumericalScore(percentScore: number) {
  return Math.round(percentScore * 100);
}
